<template>
  <div>
    <Dialog
      :id="'dialogListNuvem'"
      ref="dialogListNuvem"
      :hide-header="true"
      :hideFooter="true"
      :modal="true"
      :tamanho="'xl'"
      :classModalBody="'mx-5 mx-xl-1 my-1'"
      @dialog-off="fechar()"
    >
      <NuvemList
        ref="listNuvem"
        :dialog="true"
        :botaoNovo="botaoNovo"
        @dialog-on="fechar()"
        @dialog-off="abrirEvento()"
      />

      <template #header>
        <div class="m-9 mb-0">
          <div class="d-flex justify-content-between">
            <div>
              <h1 class="d-flex text-primary fw-bolder fs-2 mt-2" v-if="true">
                {{ nomeCliente }}
                <span
                  class="h-22px border-1 border-gray-200 border-start ms-3 mx-2 me-1"
                  v-if="true"
                ></span>
                <span class="text-dark fw-bold fs-7 ms-2 mt-2" v-if="true"
                  >Nuvens</span
                >
              </h1>
            </div>

            <div
              class="btn btn-sm btn-icon btn-active-color-primary"
              data-bs-dismiss="modal"
            >
              <span class="svg-icon svg-icon-1" @click="$emit('dialog-off')">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <rect
                    opacity="0.5"
                    x="6"
                    y="17.3137"
                    width="16"
                    height="2"
                    rx="1"
                    transform="rotate(-45 6 17.3137)"
                    fill="currentColor"
                  ></rect>
                  <rect
                    x="7.41422"
                    y="6"
                    width="16"
                    height="2"
                    rx="1"
                    transform="rotate(45 7.41422 6)"
                    fill="currentColor"
                  ></rect>
                </svg>
              </span>
            </div>
          </div>
          <div class="separator m-0 mt-3" v-if="true"></div>
        </div>
      </template>
    </Dialog>
  </div>
</template>

<script>
import { api } from "@/plugins/api.js";

import NuvemList from "./NuvemList.vue";
import Dialog from "../components/ComponentDialog.vue";

export default {
  components: { NuvemList, Dialog },
  props: {
    botaoNovo: { type: Boolean, default: true }
  },

  data() {
    return {
      filtroCliente: "",
      filtroStorage: "",
      nomeCliente: ""
    };
  },

  mounted() {},

  methods: {
    async abrirEvento() {
      if (this.filtroCliente !== "") {
        this.abrir(this.filtroCliente);
      } else if (this.filtroStorage !== "") {
        this.abrirStorage(this.filtroStorage);
      }
    },

    async abrir(cliente) {
      //* Limpa os campos
      this.nomeCliente = "-";

      //* Carrega os dados da api
      const response = await api.get(
        window._env_.VUE_APP_URL_API + "/admin/cliente/" + cliente
      );

      //* Verifica se econtrou
      if (response.data.itens.length > 0) {
        const itemCliente = response.data.itens[0];
        this.nomeCliente = itemCliente.nome;

        //* Armazena o cliente a ser carregado
        this.filtroCliente = cliente;

        //* Passa para a lista os totais
        this.$refs.listNuvem.estatisticas.espacoTotal = itemCliente.espacoTotal;
        this.$refs.listNuvem.estatisticas.espacoAlocado =
          itemCliente.espacoAlocado;
        this.$refs.listNuvem.estatisticas.espacoOcupado =
          itemCliente.espacoOcupado;
        this.$refs.listNuvem.estatisticas.usuariosTotal =
          itemCliente.usuariosTotal;
        this.$refs.listNuvem.estatisticas.usuariosAlocado =
          itemCliente.usuariosAlocado;
        this.$refs.listNuvem.estatisticas.usuariosOcupado =
          itemCliente.usuarios.length;

        //* Filtra o cliente e carrega os itens e abre a dialog
        this.$refs.listNuvem.filtroCliente = this.filtroCliente;
        this.$refs.listNuvem.filtroStorage = "";
        this.$refs.listNuvem.carregarItens();
        this.$refs.dialogListNuvem.abrir();
      }
    },
    async abrirStorage(storage) {
      //* Limpa os campos
      this.nomeCliente = "-";

      //* Carrega os dados da api
      const response = await api.get(
        window._env_.VUE_APP_URL_API + "/admin/storage/" + storage
      );

      //* Verifica se econtrou
      if (response.data.itens.length > 0) {
        const itemStorage = response.data.itens[0];
        this.nomeCliente = itemStorage.nome;

        //* Armazena o cliente a ser carregado
        this.filtroStorage = storage;

        //* Filtra o cliente e carrega os itens e abre a dialog
        this.$refs.listNuvem.filtroStorage = this.filtroStorage;
        this.$refs.listNuvem.filtroCliente = "";
        this.$refs.listNuvem.carregarItens();
        this.$refs.dialogListNuvem.abrir();
      }
    },
    fechar() {
      this.$refs.dialogListNuvem.fechar();
    }
  }
};
</script>

<style></style>
